export function gridFields() {
    return Object.freeze([{
      key: 'id',
      label: 'lbl.processEnergy.id',
      uneditable: true,
      notInTable: true,
      sortable: true,
      form: {
        type: 'input'
      }
    },
    {
      key: 'optionId',
      label: 'lbl.processEnergy.optionId',
      notInTable: true,
      uneditable: true,
      sortable: true,
      form: {
        type: 'dimSearch',
        url: process.env.VUE_APP_MASTER_API_URL + 'master-service/master/processOption/findAll',
        config: {
          validate: "", // 参数检查，可以是正则表达式等
          bindId: 'processOption', // 绑定的 id, (id 相同的对象会被绑定)
          bindProp: "id", // 显示的属性的名称
          submitProp: "id" // 提交的属性
        }
      }
    },
    {
      key: 'optionName',
      label: 'lbl.processEnergy.optionName',  
      filterable: true, 
      sortable: true, 
      required: true,   
      form: {
        type: 'dimSearch',
        url: process.env.VUE_APP_MASTER_API_URL + 'master-service/master/processOption/findAll',
        config: {
          validate: "", // 参数检查，可以是正则表达式等
          bindId: 'processOption', // 绑定的 id, (id 相同的对象会被绑定)
          bindProp: "name", // 显示的属性的名称
          submitProp: "name" // 提交的属性
        }
      }
    },
    
    {
      key: 'energyId',
      label: 'lbl.processEnergy.energyId',     
      notInTable: true,
      uneditable: true,
      form: {
        type: 'dimSearch',
        url: process.env.VUE_APP_MASTER_API_URL + 'master-service/master/energy/findAll',
        config: {
          validate: "", // 参数检查，可以是正则表达式等
          bindId: 'processEnergy', // 绑定的 id, (id 相同的对象会被绑定)
          bindProp: "id", // 显示的属性的名称
          submitProp: "id" // 提交的属性
        }
      }
    },
    {
      key: 'energyCode',
      label: 'lbl.processEnergy.energyCode',   
      sortable: true, 
      required: true, 
      form: {
        type: 'dimSearch',
        url: process.env.VUE_APP_MASTER_API_URL + 'master-service/master/energy/findAll',
        config: {
          validate: "", // 参数检查，可以是正则表达式等
          bindId: 'processEnergy', // 绑定的 id, (id 相同的对象会被绑定)
          bindProp: "enyCode", // 显示的属性的名称
          submitProp: "enyCode" // 提交的属性
        }
      }
    },    
    {
      key: 'energyName',
      label: 'lbl.processEnergy.energyName',  
      sortable: true, 
      required: true,    
      form: {
        type: 'dimSearch',
        url: process.env.VUE_APP_MASTER_API_URL + 'master-service/master/energy/findAll',
        config: {
          validate: "", // 参数检查，可以是正则表达式等
          bindId: 'processEnergy', // 绑定的 id, (id 相同的对象会被绑定)
          bindProp: "enyName", // 显示的属性的名称
          submitProp: "enyName" // 提交的属性
        }
      }
    },
    {
      key: 'energyUnit',
      label: 'lbl.processEnergy.unit',
      form: {
        type: 'input'          
      }
    }
    ]);
  }
  
  function nextYear() {
    const current = new Date;
    return new Date(current.getFullYear() + 1, current.getMonth(), current.getDate())
  }
  
  // class
  export const ProcessEnergy = function () {
    gridFields().forEach(item => {
      this[item.key] = item.default || '';
    })
  }
  
  
  export const filter = gridFields()
    .filter(v => v.filterable)
    .reduce((tar, v) => {
      tar[`${v.key}Filter`] = v.default || '';
      return tar
    }, {})
  export const filterFields = gridFields().filter(v => v.filterable).map(v => `filter.${v.key}`)